/**
 * bucket
 * {
 * id : '',
 * owner : '',
 * title : '',
 * description : '',
 * color : 1 //can be 1,2,3,4,5
 * }
 */
import http from '@/lib/http.js';
import UUID from '@/lib/uuid.js';
import getDomain from '@/lib/get-domain.js';
import moment from 'moment';

import api from '@/lib/api.js';

var store = {
	namespaced: true,
	state: {
		notes: [],
		selectedNotes: []
	},
	getters: {
		selectedNotes: function(state) {
			return state.selectedNotes;
		},
		notes: function(state) {
			return state.notes;
		},
		note: function(state) {
			return id => {
				let n = false;
				state.notes.map(note => {
					if (note.id === id) {
						n = note;
					}
				});
				return n;
			};
		},
		sampleNote: function() {
			return {
				_id: '601fd851387f952230164814',
				id: 'c02bc04f-5927-44d6-899f-36705b6d6239',
				owner: '5fc8c620d0153fc290a65c10',
				bucket: '60138eb9d3054936799e7ba9',
				folder: '601945bfac93e7ca5c7ddccd',
				createdAt: '2021-02-07T12:08:49.468Z',
				updatedAt: null,
				domain: 'news.ycombinator.com',
				range: {
					startContainerPath:
						'//table[@id="hnmain"]/tbody/tr[3]/td/table[2]/tbody/tr[14]/td/table/tbody/tr/td[3]/div[2]/span/text()',
					startOffset: 0,
					endContainerPath:
						'//table[@id="hnmain"]/tbody/tr[3]/td/table[2]/tbody/tr[14]/td/table/tbody/tr/td[3]/div[2]/span/p/text()',
					endOffset: 94
				},
				href: 'https://news.ycombinator.com/item?id=26048946',
				text:
					"+1000 I've been trying to do this (split into sections and eliminate umms) with recordings of live classes... it takes me 4 hours per each hour of recording.\nif you can make this process faster the world will throw money at your feet.. at least I will",
				ref: 'https://news.ycombinator.com/item?id=26048946',
				type: 'text',
				meta: {
					title:
						'Show HN: You-tldr – easy-to-read transcripts of Youtube videos | Hacker News',
					profile: {
						username: 'elviejo',
						url: 'https://news.ycombinator.com/user?id=elviejo'
					},
					position: '39.58'
				},
				__v: 0,
				comment: {
					raw: 'This is a note',
					json: {
						type: 'doc',
						content: [
							{
								type: 'paragraph',
								content: [{ type: 'text', text: 'This is a note' }]
							}
						]
					},
					html: '<p>This is a note</p>'
				}
			};
		}
	},
	mutations: {
		CLEAR_SELECTION: function(store) {
			store.selectedNotes = [];
		},
		TOGGLE_SELECTION: function(store, note) {
			if (store.selectedNotes.includes(note.id)) {
				let i = store.selectedNotes.indexOf(note.id);
				store.selectedNotes.splice(i, 1);
			} else {
				store.selectedNotes.push(note.id);
			}
		},
		ACTIVATE_SELECTION: function(store, note) {
			if (store.selectedNotes.includes(note.id)) {
			} else {
				store.selectedNotes.push(note.id);
			}
		},
		DEACTIVATE_SELECTION: function(store, note) {
			if (store.selectedNotes.includes(note.id)) {
				let i = store.selectedNotes.indexOf(note.id);
				store.selectedNotes.splice(i, 1);
			}
		},
		ADD_NOTE: function(state, data) {
			state.notes.push(data);
		},
		REMOVE_NOTE: function(state, id) {
			var notes = state.notes;
			notes = notes.filter(n => {
				if (n.id === id) {
					return false;
				} else {
					return true;
				}
			});
			state.notes = notes;
		},
		UPDATE_NOTE: function(state, note) {
			var id = note.id;
			var notes = state.notes.map(n => {
				if (n.id === id) {
					n = note;
				}
				return n;
			});
			state.notes = notes;
		},
		UPDATE_NOTE_BULK: function(state, notes) {
			var arr = state.notes.map(note => {
				for (var i = 0; i < notes.length; i++) {
					if (note.id === notes[i].id) {
						note = notes[i];
						break;
					}
				}
				return note;
			});
			state.notes = arr;
		},
		REMOVE_NOTE_BULK: function(state, ids) {
			var notes = state.notes;
			notes = notes.filter(n => {
				if (ids.includes(n.id)) {
					return false;
				} else {
					return true;
				}
			});
			state.notes = notes;
		},
		SET_NOTES: function(state, notes) {
			state.notes = notes;
		}
	},
	actions: {
		async exportIntegration(context, integration) {
			if (integration === 'readwise') {
				let notes = context.state.notes;
				let selectedNotes = context.state.selectedNotes;
				let results = [];
				for (let i = 0; i < notes.length; i++) {
					if (selectedNotes.includes(notes[i].id)) {
						results.push(notes[i]);
					}
				}
				let payload = {
					notes: results
				};
				return http
					.request('post', '/notes/readwise', payload)
					.then(res => {})
					.catch(err => {
						console.log(err);
					});
			}
		},
		async getNotes(context) {
			let res = await api.notes.getNotes();
			if (res) {
				context.commit('SET_NOTES', res.data);
			}
			return res;
		},
		async removeNote(context, noteId) {
			let res = await api.notes.removeNote(noteId);
			if (res) {
				context.commit('REMOVE_NOTE', noteId);
				return res;
			} else {
				return null;
			}
		},
		removeNotesBucket: function(context, bucketId) {
			let notes = context.state.notes;
			notes = notes.filter(n => {
				if (n.bucket === bucketId) {
					return true;
				} else {
					return false;
				}
			});
			if (notes.length !== 0) {
				notes = notes.map(n => {
					n.bucket = null;
					return n;
				});
				context.dispatch('bulkUpdateNotes', notes);
			}
		},
		removeNotesFolder: function(context, folderId) {
			let notes = context.state.notes;
			notes = notes.filter(n => {
				if (n.folder === folderId) {
					return true;
				} else {
					return false;
				}
			});
			if (notes.length !== 0) {
				notes = notes.map(n => {
					n.folder = null;
					return n;
				});
				context.dispatch('bulkUpdateNotes', notes);
			}
		},
		bulkRemoveNotes: function(context, ids) {
			var data = {
				ids: ids
			};
			return new Promise((resolve, reject) => {
				http.request('delete', '/notes/bulk', data).then(res => {
					context.commit('REMOVE_NOTE_BULK', ids);
					resolve(ids);
				});
			});
		},
		async updateNote(context, note) {
			let res = await api.notes.updateNote(note);
			if (res) {
				context.commit('UPDATE_NOTE', note);
				return note;
			} else {
				return null;
			}
		},
		fetchSpecificNotes: function(context, ids) {
			let form = {
				notes: ids
			};
			return new Promise(resolve => {
				http.request('post', '/notes/get', form).then(res => {
					if (res.data) {
						resolve(res.data);
					} else {
						resolve([]);
					}
				});
			});
		},
		bulkUpdateNotes: function(context, notes) {
			var data = {
				notes: notes
			};
			return new Promise((resolve, reject) => {
				http.request('put', '/notes/bulk', data).then(res => {
					context.commit('UPDATE_NOTE_BULK', notes);
					//context.dispatch("message/onNotesUpdated", null, { root: true });
				});
			});
		},
		async bookmark(store, form) {
			let data = await store.dispatch('createBookmark', form);
			return data;
		},
		async createBookmark(context, form) {
			if (context.rootGetters['user/isOverTrial']) {
				return false;
			}
			let link = form.url;
			let notes = context.rootGetters['note/notes'];
			let isBookmarked = false;
			for (var i = 0; i < notes.length; i++) {
				if (notes[i].ref === link) {
					if (notes[i].type === 'bookmark') {
						isBookmarked = true;
					}
				}
			}
			if (isBookmarked) {
				return false;
			} else {
				let metadata = {};
				let note = {
					id: UUID(),
					createdAt: moment().toISOString(),
					updatedAt: '',
					domain: getDomain(form.url),
					comment: {},
					bucket: form.bucket || null,
					range: null,
					href: window.location.href,
					text: '',
					ref: form.url,
					type: 'bookmark',
					folder: form.folder || null,
					meta: metadata
				};
				return context.dispatch('createNote', note);
			}
		},
		createNote: function(context, note) {
			var form = {
				note: note
			};
			return new Promise((resolve, reject) => {
				http.request('post', '/notes', form).then(res => {
					if (!res) {
						resolve(false);
					} else {
						context.commit('ADD_NOTE', res.data);
						resolve(res.data);
					}
				});
			});
		}
	}
};

export default store;
